"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDaysWithMissedPunchCorrection = void 0;
const luxon_1 = require("luxon");
const useDaysWithMissedPunchCorrection = ({ punchCorrections }) => {
    return ((punchCorrections === null || punchCorrections === void 0 ? void 0 : punchCorrections.map(({ correctionDateTime }) => luxon_1.DateTime.fromISO(correctionDateTime))) || []);
};
exports.useDaysWithMissedPunchCorrection = useDaysWithMissedPunchCorrection;
